const CategoryProductSortOption = {
  NAME: 'NAME',
  MODEL: 'MODEL',
  MANUFACTURER: 'MANUFACTURER',
  CHEAPEST: 'CHEAPEST',
  MOST_EXPENSIVE: 'MOST_EXPENSIVE',
  MOST_SOLD: 'MOST_SOLD',
  LATEST: 'LATEST',
  BEST_RATED: 'BEST_RATED',
  PRODUCT_NUMBER: 'PRODUCT_NUMBER',
  CATEGORY: 'CATEGORY',
  DISCOUNT: 'DISCOUNT',
  IN_STOCK_QUANTITY: 'IN_STOCK_QUANTITY',
};

export default CategoryProductSortOption;
